(function () {
  var root = document.getElementById('rd-custom-cod');
  if (!root) return;

  var runtimeUrl = String(root.getAttribute('data-runtime-url') || '').trim();
  if (!runtimeUrl) return;

  var started = false;
  var idleId = null;
  var pointerEventName = 'PointerEvent' in window ? 'pointerdown' : 'touchstart';
  var eagerEventNames = [pointerEventName, 'focusin', 'keydown'];
  var cartIntentSelector = [
    '[data-testid="cart-drawer-trigger"]',
    'cart-drawer-component > button[aria-haspopup="dialog"]',
    'a.action__cart[href*="/cart"]',
    'a[href*="/cart"]',
  ].join(',');

  function removeEagerListeners() {
    eagerEventNames.forEach(function (eventName) {
      document.removeEventListener(eventName, start, true);
    });
    if (idleId !== null && window.cancelIdleCallback) window.cancelIdleCallback(idleId);
  }

  function removeCartIntentListeners() {
    document.removeEventListener(pointerEventName, handleCartIntent, true);
    document.removeEventListener('click', handleCartIntent, true);
    document.removeEventListener('cart:update', start, true);
    document.querySelectorAll('cart-drawer-component').forEach(function (drawer) {
      drawer.removeEventListener('dialog:open', start);
    });
  }

  function cleanup() {
    removeEagerListeners();
    removeCartIntentListeners();
  }

  function start() {
    if (started) return;
    started = true;
    cleanup();
    root.setAttribute('data-runtime-state', 'loading');

    var script = document.createElement('script');
    script.src = runtimeUrl;
    script.async = true;
    script.setAttribute('data-rd-custom-cod-runtime', 'true');
    script.onload = function () {
      root.setAttribute('data-runtime-state', 'ready');
      dispatchRuntimeEvent('rudedog:cod-runtime-ready');
    };
    script.onerror = function () {
      root.setAttribute('data-runtime-state', 'error');
      dispatchRuntimeEvent('rudedog:cod-runtime-error');
    };
    document.head.appendChild(script);
  }

  function hasPendingBeamReturn() {
    try {
      var stored = window.localStorage && window.localStorage.getItem('rd_beam_return_v2');
      if (stored && /WEB-[A-F0-9]{32}/i.test(stored)) return true;
    } catch (error) {}
    return /(?:^|;\s*)rd_beam_pending=WEB-[A-F0-9]{32}(?:;|$)/i.test(document.cookie || '');
  }

  function dispatchRuntimeEvent(eventName) {
    var event;
    try {
      event = new CustomEvent(eventName);
    } catch (error) {
      event = document.createEvent('Event');
      event.initEvent(eventName, false, false);
    }
    window.dispatchEvent(event);
  }

  function handleCartIntent(event) {
    var target = event.target;
    if (target && target.nodeType !== 1) target = target.parentElement;
    if (target && target.closest && target.closest(cartIntentSelector)) start();
  }

  function isCommerceCriticalPage() {
    var context = String(root.getAttribute('data-context') || '').toLowerCase();
    var path = String(window.location && window.location.pathname || '');
    return context === 'product' || /(^|\/)cart(?:\/|$)/.test(path);
  }

  function scheduleEagerStart() {
    eagerEventNames.forEach(function (eventName) {
      document.addEventListener(eventName, start, true);
    });

    if (window.requestIdleCallback) {
      idleId = window.requestIdleCallback(start, { timeout: 700 });
    } else {
      window.setTimeout(start, 120);
    }
  }

  function waitForCartIntent() {
    root.setAttribute('data-runtime-state', 'deferred');
    document.addEventListener(pointerEventName, handleCartIntent, true);
    document.addEventListener('click', handleCartIntent, true);
    document.addEventListener('cart:update', start, true);
    document.querySelectorAll('cart-drawer-component').forEach(function (drawer) {
      drawer.addEventListener('dialog:open', start);
    });

    if (document.querySelector('cart-drawer-component dialog[open], .cart-drawer__dialog[open]')) {
      start();
    }
  }

  if (hasPendingBeamReturn()) {
    start();
  } else if (isCommerceCriticalPage()) {
    scheduleEagerStart();
  } else {
    waitForCartIntent();
  }
})();
